import { Image, Menu, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Logo from "../../assets/images/Logo.svg";
import DashboardIcon from "../../assets/images/Sidenav_Icon/Dashbord.svg";
import StudentsIcon from "../../assets/images/Sidenav_Icon/Student-management.svg";
import BranchIcon from "../../assets/images/Sidenav_Icon/Branch-management.svg";
import EmployeesIcon from "../../assets/images/Sidenav_Icon/employment-management.svg";
import ClassesIcon from "../../assets/images/Sidenav_Icon/class-management.svg";
import NotificationIcon from "../../assets/images/Sidenav_Icon/Notification-management.svg";
import TransactionsIcon from "../../assets/images/Sidenav_Icon/transaction-management.svg";
import EmailTemplateIcon from "../../assets/images/Sidenav_Icon/email-management.svg";
import ContentIcon from "../../assets/images/Sidenav_Icon/content-management.svg";
import SubscriptionsIcon from "../../assets/images/Sidenav_Icon/subscription-management.svg";
import EventsIcon from "../../assets/images/Sidenav_Icon/event-managemnet.svg";
import SubscriptionRequestIcon from "../../assets/images/Sidenav_Icon/subscription-request-management.svg";
import AttendenceIcon from "../../assets/images/Sidenav_Icon/attendance-management.svg";
import BeltIcon from "../../assets/images/Sidenav_Icon/belt-management.svg";
import ReportsIcon from "../../assets/images/Sidenav_Icon/report-management.svg";
import LogOutImg from "../../assets/images/Sidenav_Icon/logout-management.svg";

import { AuthContext } from "../../context/AuthContext";
import lang from "../../helper/langHelper";
import DeleteModal from "../DeleteModal";
import moment from "moment";

export const countryWithAreas = [
  "646b2e0f46865f1f65565346", //Palestine
];

export const menuItems = [
  {
    key: "dashboard-management",
    path: "/dashboard",
    icon: DashboardIcon,
    label: lang("Dashboard"),
    isShow: true,
    srNo: 1,
  },
  {
    key: "city-management",
    path: "/cities",
    icon: StudentsIcon,
    label: lang("City Management"),
    isShow: true,
    srNo: 112,
  },
  {
    key: "student-management",
    path: "/students",
    icon: StudentsIcon,
    label: lang("Student/Parent Management"),
    isShow: true,
    srNo: 2,
  },
  {
    key: "branch-management",
    path: "/branches",
    icon: BranchIcon,
    label: lang("Branch Management"),
    isShow: true,
    srNo: 3,
  },
  {
    key: "employee-management",
    path: "/employees",
    icon: EmployeesIcon,
    label: lang("Employee Management"),
    isShow: true,
    srNo: 4,
  },
  {
    key: "class-attendance-manager",
    path: "/classattendance-manager",
    icon: EmployeesIcon,
    label: lang("Class Attendance Manager"),
    isShow: true,
    srNo: 14,
  }
  ,
  {
    key: "belt-management",
    path: "/branch-belts",
    icon: BeltIcon,
    label: lang("Belt Management"),
    isShow: true,
    srNo: 12,
  },
  {
    key: "kyu-management",
    path: "/kyu",
    icon: BeltIcon,
    label: lang("Kyu Management"),
    isShow: true,
    srNo: 18,
  },
  {
    key: "class-management",
    path: "/classes",
    icon: ClassesIcon,
    label: lang("Class Management"),
    isShow: true,
    srNo: 5,
  },
  {
    key: "booking-management",
    path: "/booking",
    icon: ContentIcon,
    label: lang("Booking Management"),
    isShow: true,
    srNo: 21,
  },
  {
    key: "studentprogress-management",
    path: "/student-progress",
    icon: AttendenceIcon,
    label: lang("Student Progress Management"),
    isShow: true,
    srNo: 15,
  },
  {
    key: "attendence-management",
    path: "/attendence",
    icon: AttendenceIcon,
    label: lang("Attendence Management"),
    isShow: true,
    srNo: 15,
  },
  {
    key: "exam-management",
    path: "/exam",
    icon: TransactionsIcon,
    label: lang("Exam Management"),
    isShow: true,
    srNo: 29,
  },
  {
    key: "graduation-management",
    path: "/graduation",
    icon: ReportsIcon,
    label: lang("Graduation Management"),
    isShow: true,
    srNo: 28,
  },
  {
    key: "event-management",
    path: "/event",
    icon: EventsIcon,
    label: lang("Event Management"),
    isShow: true,
    srNo: 51,
  },
  {
    key: "notification-management",
    path: "/notification",
    icon: NotificationIcon,
    label: lang("Notification Management"),
    isShow: true,
    srNo: 6,
  },
  {
    key: "transaction-management",
    path: "/transactions",
    icon: TransactionsIcon,
    label: lang("Transaction Management"),
    isShow: true,
    srNo: 7,
  },
  {
    key: "email-template-management",
    path: "/email-template",
    icon: EmailTemplateIcon,
    label: lang("Email Template Management"),
    isShow: true,
    srNo: 8,
  },
  {
    key: "content-management",
    path: "/content",
    icon: ContentIcon,
    label: lang("Content Management"),
    isShow: true,
    srNo: 9,
  },
  {
    key: "banner-management",
    path: "/banner",
    icon: ContentIcon,
    label: lang("Banner Management"),
    isShow: true,
    srNo: 9,
  },
  // {
  //   key: "subscription-management",
  //   path: "/subscriptions",
  //   icon: SubscriptionsIcon,
  //   label: lang("Subscription Management"),
  //   isShow: true,
  //   srNo: 10,
  // },
  {
    key: "subscription-request-management",
    path: "/subscriptionrequest",
    icon: SubscriptionRequestIcon,
    label: lang("Subscription Request Management"),
    isShow: true,
    srNo: 11,
  },
  {
    key: "static-content-management",
    path: "/static-content",
    icon: EventsIcon,
    label: lang("Static Content Management"),
    isShow: true,
    srNo: 17,
  },
  {
    key: "reports-management",
    path: "/reports",
    icon: ReportsIcon,
    label: lang("Reports Management"),
    isShow: true,
    srNo: 13,
  },
];

function Sidenav({ color }) {
  const { logout, userProfile } = useContext(AuthContext);
  const [loading,] = useState(false);
  const [menuLinks, setMenuLinks] = useState(menuItems);
  const [menuMode, setMenuMode] = useState("vertical");
  const [currentDateTime, setCurrentDateTime] = useState(moment());
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  // const showDeleteConfirm = (record) => {
  //   logout();
  // };

  useEffect(() => {
    const userRole = userProfile?.role;
    if (userRole === "admin") {
      return setMenuLinks(menuItems);
    }
    const permissions =
      JSON.parse(localStorage.getItem("permission") || "{}")?.permissions || [];
    const permissionKeys = new Set(
      permissions.filter((per) => per.isView).map((per) => per.key)
    );
    const filterMenu = menuItems.filter((item) => permissionKeys.has(item.key));
    setMenuLinks(filterMenu);
  }, [userProfile]);

  const renderTitle = (item) => {
    return (
      <>
        <Image preview={false} src={item.icon} />
        <span className="label">{item.label}</span>
      </>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode("inline");
      } else {
        setMenuMode("vertical");
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const updateDateTime = () => {
      setCurrentDateTime(moment());
    };

    const intervalId = setInterval(updateDateTime, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      {loading ? (
        [1, 2, 3, 4, 5, 6].map((item) => <Skeleton active key={item} />)
      ) : (
        <>
          <div className="brand-logo">
            <NavLink to="" className="imgOuter">
              <img className="" src={Logo} alt="" />
              {/* <span>
                <h1>
                  <b>I am Dojo</b>
                </h1>
              </span> */}
            </NavLink>
            <p>{currentDateTime.format("DD/MM/YYYY hh:mm a")}</p>
          </div>
          <Menu inlineCollapsed={false} mode={menuMode} className="sideNavMain">
            {menuLinks.map((item) => {
              if (item.children) {
                return (
                  <>
                    <Menu.SubMenu
                      key={item.key}
                      title={
                        <>
                          <span className="icon">
                            <Image preview={false} src={item.icon} />
                          </span>
                          <span className="label">{item.label}</span>
                        </>
                      }
                    >
                      {item.children.map((child) => (
                        <Menu.Item key={child.key}>
                          <NavLink to={child.path}>{child.label}</NavLink>
                        </Menu.Item>
                      ))}
                    </Menu.SubMenu>
                  </>
                );
              }

              return (
                <Menu.Item key={item.key}>
                  <NavLink to={item.path}>{renderTitle(item)}</NavLink>
                </Menu.Item>
              );
            })}

            <Menu.Item
              onClick={() => {
                setIsLogoutModalVisible(true);
              }}
            >
              <NavLink to={"#"}>
                <>
                  <Image preview={false} src={LogOutImg} />
                  <span className="label">{lang("Logout")}</span>
                </>
              </NavLink>
            </Menu.Item>
          </Menu>
        </>
      )}
      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to Logout?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => logout()}
        />
      )}
    </>
  );
}

export default Sidenav;
